import { useCallback, useState } from 'react';

const INITIAL_STATE = { open: false, title: 'Please Confirm', message: '', onConfirm: null };

// Shared imperative-confirm -> RMSConfirmationDialog bridge so callers can keep writing
// `requestConfirm(message, doTheThing)` instead of wiring open/onYes/onNo state each time.
const useConfirmDialog = () => {
  const [confirmState, setConfirmState] = useState(INITIAL_STATE);

  const requestConfirm = useCallback((message, onConfirm, title = 'Please Confirm') => {
    setConfirmState({ open: true, title, message, onConfirm });
  }, []);

  const handleYes = useCallback(() => {
    confirmState.onConfirm?.();
    setConfirmState(INITIAL_STATE);
  }, [confirmState]);

  const handleNo = useCallback(() => {
    setConfirmState(INITIAL_STATE);
  }, []);

  return { confirmState, requestConfirm, handleYes, handleNo };
};

export default useConfirmDialog;
